<div class="container-fluid">
  <div class="row">
    <div class="col-12 position-relative d-flex mb-3">
      <!-- Scrollable sheets container -->
      <div class="sheets-container overflow-auto flex-grow-1" style="margin-right: 100px;">
        <div class="d-flex align-items-center" style="min-height: 38px;">
          <div
            class="dropdown me-2"
            *ngFor="let sheet of sheets; let i = index"
          >
            <button
              class="btn bg-light border rounded-top text-truncate position-relative"
              type="button"
              id="dropdownMenuButton_{{ i }}"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              [class.bg-white]="sheet.loaded"
              [class.border-bottom-0]="sheet.loaded"
              (click)="switchSheetIfDifferent(sheet)"
              style="min-width: 120px; height: 38px; padding-right: 28px;"
            >
              <span *ngIf="!sheet.isSheetNameEdit" class="text-truncate d-block text-secondary">{{ getSheetName(sheet) }}</span>
              <input
                class="form-control form-control-sm py-0"
                *ngIf="sheet.isSheetNameEdit"
                [(ngModel)]="sheet.editedSheetName"
                (focusout)="stopEditingSheet(sheet)"
                (click)="$event.stopPropagation()"
              />
              <span class="dropdown-toggle position-absolute end-0 top-50 translate-middle-y pe-none me-2"></span>
            </button>
      
            <ul class="dropdown-menu shadow-sm position-fixed" style="z-index: 1050;" [class.show]="sheet.showDropDown">
              <li>
                <input
                  type="file"
                  class="file-input d-none"
                  (change)="uploadsheet($event, sheet)"
                  #fileUpload
                />
                <a class="dropdown-item" (click)="fileUpload.click()">
                  <i class="bi bi-cloud-upload me-2"></i>Import Data
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" (click)="editSheetName(sheet)">
                  <i class="bi bi-pencil me-2"></i>Rename sheet
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="duplicateSheet(sheet)">
                  <i class="bi bi-copy me-2"></i>Duplicate sheet
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a
                  class="dropdown-item text-danger"
                  (click)="openDeleteModal(sheet.id)"
                >
                  <i class="bi bi-trash me-2"></i>Delete sheet
                </a>
              </li>
            </ul>
          </div>

          <button 
            class="btn bg-light border rounded-top d-flex align-items-center justify-content-center me-2" 
            (click)="createNewSheet()" 
            [disabled]="newSheetLoading"
            style="width: 38px; height: 38px;"
          >
            <i class="bi" [class.bi-plus]="!newSheetLoading" [class.bi-hourglass-split]="newSheetLoading"></i>
          </button>
        </div>
      </div>

      <!-- Vertical separator and action buttons -->
      <div class="position-absolute end-0 top-0 h-100 d-flex align-items-center" style="margin-top: 0;">
        <div class="border-start h-100 me-2"></div>
        <!-- Fixed action buttons -->
        <div class="d-flex gap-2 bg-white">
          <button class="btn btn-light" style="height: 38px; line-height: 24px; background-color: white;" (click)="openDownloadModal()">
            <i class="bi bi-download"></i>
          </button>
          <button class="btn btn-light" style="height: 38px; line-height: 24px; background-color: white;" (click)="cleanSpreadsheet()">
            <i class="bi bi-eraser"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div id="x-spreadsheet-demo" #spreadsheetContainer></div>
    </div>
  </div>
</div>

<!-- Delete Sheet Modal -->
<ng-template #deleteSheetModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Delete Sheet</h4>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this sheet?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="deleteSheet(selectedSheetToDelete); modal.close()">Delete</button>
  </div>
</ng-template>

<!-- Download Modal -->
<ng-template #downloadModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Download</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column gap-2">
      <button class="btn btn-primary" [disabled]="downloadLoading.xlsx" (click)="downloadXlsx()">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="downloadLoading.xlsx"></span>
        Download XLSX
      </button>
      <button class="btn btn-primary" [disabled]="downloadLoading.csv" (click)="downloadCsv()">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="downloadLoading.csv"></span>
        Download CSV
      </button>
    </div>
  </div>
</ng-template>
  